/**
 * Pre-compiled localized messages for LocalizedField component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import localizedFieldMessages_en from "./intl/en";
import localizedFieldMessages_de from "./intl/de";
import localizedFieldMessages_es from "./intl/es";
import localizedFieldMessages_fr from "./intl/fr-FR";
import localizedFieldMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const localizedFieldMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(localizedFieldMessages_en),
  de: normalizeMessages(localizedFieldMessages_de),
  es: normalizeMessages(localizedFieldMessages_es),
  "fr-FR": normalizeMessages(localizedFieldMessages_fr),
  "pt-BR": normalizeMessages(localizedFieldMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for LocalizedField component
 */
export type LocalizedFieldMessageKey =
  | "hideCurrencies"
  | "hideLanguages"
  | "infoBoxTriggerAriaLabel"
  | "missingRequiredField"
  | "showCurrencies"
  | "showLanguages";
